import React from 'react';
import { GlassModal, GlassModalHeader, GlassModalBody, GlassModalFooter } from '../../components/GlassModal';
import GlassDataTable from '../../components/GlassDataTable';
import './incidents-view.css';
import '../../styles/page-common.css';
import Alert from "../../components/glass/GlassAlert";
import { colors } from '../../theme';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import DateFilter from '../../components/DateFilter';
import ItemEditComponent from '../../components/TextEdit'
import DownloadLink from "react-download-link";
import urls from '../../network/urls';
import moment from 'moment';
import Invoice from '../../components/invoice';
import { format } from '../../helpers/invoiceNumber';

const Page = ({ incidents, entities, dispatchFixIncident }) => {

  const [selectedItem, setSelectedItem] = React.useState();
  const [selectedClient, setSelectedClient] = React.useState();

  const entityData = {
    columns: [
      {
        label: 'Client',
        field: 'client',
        sort: 'asc'
      },
      {
        label: '',
        field: 'select',
        sort: 'asc'
      }
    ],
    rows: entities.map(i => {
      return {
        client: i.surname ? i.name + ' ' + i.surname : i.name,
        select: <button type='button' style={{ background: 'rgba(13,161,178,0.12)', border: '1px solid rgba(13,161,178,0.25)', color: 'var(--primary-dark)', borderRadius: 8, padding: '5px 14px', fontWeight: 600, fontSize: 12, cursor: 'pointer' }} onClick={() => {
          setSelectedClient(i);
        }}>
          View
        </button>
      }
    })
  };

  const data = {
    columns: [
      {
        label: 'Incident Date',
        field: 'date',
        sort: 'asc'
      },
      {
        label: 'Description',
        field: 'description',
        sort: 'asc'
      },
      {
        label: 'Value',
        field: 'value',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: '',
        field: 'view',
        sort: 'asc'
      }
    ],
    rows: incidents.incidents.map(i => {
      return {
        ...i,
        date: moment(i.date).format('YYYY-MM-DD HH:mm'),
        view: <button type='button' style={{ background: 'rgba(13,161,178,0.12)', border: '1px solid rgba(13,161,178,0.25)', color: 'var(--primary-dark)', borderRadius: 8, padding: '5px 14px', fontWeight: 600, fontSize: 12, cursor: 'pointer' }} onClick={() => {
          setSelectedItem(i);
          setSelectedClient();
        }}>
          View
        </button>
      }
    })
  };

  const incidentCount = incidents.incidents.length;
  return (<div className="content-wrapper accent-incidents" style={{ ['--list-accent']: '#E5A000', ['--list-accent-dark']: '#B87E00' }}>

    {/* Hero band */}
    <div className="gl-hero" style={{ margin: '0 6px 14px' }}>
      <div className="gl-hero-row">
        <div>
          <div className="gl-hero-title">Incidents</div>
          <div className="gl-hero-sub">{incidentCount} {incidentCount === 1 ? 'incident' : 'incidents'} flagged</div>
        </div>
      </div>
    </div>

    <div style={{ padding: '0 6px 20px' }}>
    <SpinnerView showSpinner={incidents.loading} />

    <GlassModal isOpen={!!selectedItem} size="lg" toggle={() => { setSelectedItem(); setSelectedClient(); }}>
      <GlassModalHeader toggle={() => { setSelectedItem(); setSelectedClient(); }}>Incident</GlassModalHeader>
      <GlassModalBody>

      {selectedItem && <ItemEditComponent viewOnly={true} invert={true} header={'Date'} required prop={'date'} value={moment(selectedItem.date).format('YYYY-MM-DD HH:mm')} />}
      {selectedItem && <ItemEditComponent viewOnly={true} invert={true} header={'Status'} required prop={'status'} value={selectedItem.status} />}
      {selectedItem && <ItemEditComponent viewOnly={true} invert={true} header={'Description'} required prop={'description'} value={selectedItem.description} />}
      {selectedItem && <ItemEditComponent viewOnly={true} invert={true} header={'Value'} required prop={'value'} value={selectedItem.value} />}
      {selectedClient && <ItemEditComponent viewOnly={true} invert={true} header={'New Value'} required prop={'status'} value={selectedClient.name} />}

      {!selectedClient && <div>
        <div style={{ margin: '6px 0 12px', fontWeight: 600, color: 'var(--text-secondary)' }}>Please choose the correct client</div>
        <GlassDataTable data={entityData} />
      </div>}

      </GlassModalBody>
      <GlassModalFooter>

      <button type="button" onClick={() => {
          setSelectedItem();
          setSelectedClient();
        }} style={{ background: 'rgba(15,31,46,0.06)', border: '1px solid rgba(15,31,46,0.10)', color: 'var(--text-secondary)', borderRadius: 10, padding: '9px 16px', fontWeight: 600, fontFamily: 'var(--font-display)', fontSize: 13, cursor: 'pointer' }}>Cancel</button>

        <button type="button" disabled={!selectedClient} onClick={() => {
          dispatchFixIncident(selectedItem._id, selectedClient.name);
          setSelectedItem();
          setSelectedClient();
        }} style={{ background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', border: 'none', color: '#fff', borderRadius: 10, padding: '9px 18px', fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 13, cursor: selectedClient ? 'pointer' : 'not-allowed', opacity: selectedClient ? 1 : 0.5 }}><i className="fas fa-check" style={{ marginRight: 6 }}></i>Fix</button>
      </GlassModalFooter>
    </GlassModal>

    <div>
      <GlassDataTable data={data} />
    </div>

    </div>
  </div>)
}

class HomeView extends React.Component {

  componentDidMount() {
    if (this.props.selectedCompanyId) {
      this.props.dispatchGetIncidents();
      this.props.dispatchGetEntities();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedCompanyId &&
      this.props.selectedCompanyId !== prevProps.selectedCompanyId
    ) {
      this.props.dispatchGetIncidents();
      this.props.dispatchGetEntities();
    }
  }

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    return (
      <Page
        incidents={this.props.incidents}
        entities={this.props.entities}
        dispatchFixIncident={this.props.dispatchFixIncident}
      />
    );
  }
}

export default HomeView;
